// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StatCards2__Container {\n  margin-bottom: 1.5rem !important;\n}\n\n.StatCards2__Card {\n  padding: 12px;\n}\n\n.StatCards2__Card__Items {\n  align-items: center;\n  display: flex;\n  box-sizing: border-box;\n}\n\n.StatCards2__Card__Items__text {\n  font-weight: 600 !important;\n  margin: 0rem;\n  margin-left: 0.75rem !important;\n}\n\n.StatCards2__Card__Value {\n  font-weight: 600 !important;\n  text-align: center;\n  color: gray;\n  margin: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
